<div class="hx-segmented-progress__container">
  <!-- Pills Container -->
  <div
    class="hx-segmented-progress__pills"
    role="list"
    [style.position]="easterEggEnabled() ? 'relative' : null"
    [style.--pacman-duration]="easterEggEnabled() ? pacmanDuration() + 's' : null">
    @if (easterEggEnabled()) {
      <div
        class="hx-segmented-progress__pacman"
        aria-hidden="true"
        [style.animation-duration]="pacmanDuration() + 's'"></div>
    }
    @for (pill of pills(); track pill.trackingId; let i = $index) {
      <hx-badge
        role="listitem"
        [attr.aria-current]="pill.state === 'current' ? 'step' : null"
        [attr.aria-label]="pill.ariaLabel"
        [hxTooltip]="segmentTooltip"
        [tooltipContext]="{ pill: pill }"
        tooltipPosition="top"
        [hideDelay]="120"
        [attr.tabindex]="0"
        [class]="'hx-segmented-progress__pill ' + pill.cssClass"
        [context]="pill.badgeContext"
        [style.background-color]="pill.backgroundColor"
        [style.border-color]="pill.borderColor"
        [style.flex-grow]="pill.displaySize === 'large' ? '1.3' : '1'"
        [style.--pill-index]="easterEggEnabled() ? i : null"
        [style.--pill-total]="easterEggEnabled() ? totalSegments() : null"
        [style.animation-duration]="easterEggEnabled() ? pacmanDuration() + 's' : null"
        [variant]="pill.badgeVariant"
        (click)="onPillClick(pill)"
        (keydown.enter)="onPillClick(pill)"
        (keydown.space)="onPillClick(pill)">
        <!-- Empty badge pill -->
      </hx-badge>
    }
  </div>

  <ng-template #segmentTooltip let-pill="pill">
    <span class="hx-segmented-progress__tooltip-content">
      @if (getTooltipIconHref(pill.tooltipIcon); as iconHref) {
        <svg
          class="hx-segmented-progress__tooltip-icon"
          [attr.fill]="'currentColor'"
          [attr.focusable]="false"
          [attr.width]="14"
          [attr.height]="14"
          [attr.aria-hidden]="true">
          <use [attr.href]="iconHref" />
        </svg>
      }
      <span>{{ pill.tooltipText }}</span>
    </span>
  </ng-template>

  <!-- Progress Text -->
  <span aria-live="polite" class="hx-segmented-progress__text">
    {{ progressText() }}
  </span>
</div>
